/*
 * PasswordSetup Messages
 *
 * This contains all the text for the PasswordSetup component.
 *
 */

import { defineMessages } from "utils/defineMessages";

export const scope = "app.components.PasswordSetup";

export default defineMessages(scope, {
  passwordRequirements: "Password Requirements", // NOSONAR
});
